import { API_TYPES, apiSections } from 'dmpconnectjsapp-base/constants';

import { getApiType, getInsiConfig }                                              from 'dmpconnectjsapp-base/helpers/accessors';
import { hasError, isLoading, isReady }                                           from 'dmpconnectjsapp-base/helpers/common';
import * as PropTypes                                                             from 'prop-types';
import React                                                                      from 'react';
import { connect }                                                                from 'react-redux';
import { checkAndGetINSiIdentity, getInsFromVitaleCard }                          from '../../dmpconnect/actions';
import { getPatientInsiIdentityFromAccessibleDMPsCache }                          from '../../dmpconnect/helpers/accessibleDMPList';
import { fixQualifIdentityOid, getCertifiedIdentityFromIns, getQualifiedInsINSi } from '../../dmpconnect/helpers/certifiedIdentity';
import { getInsQualification }                                                    from '../../dmpconnect/helpers/persistantData';
import CheckAccessRights                                                          from '../AccessRights/CheckAccessRights';
import Loading                                                                    from '../Common/Loading/Loading';
import SectionStatusWrapper                                                       from '../Common/SectionStatus/SectionStatusWrapper';
import TD0IdentityProvider                                                        from './TD0IdentityProvider';

const INSiIdentityProvider = ({
  dispatch,
  children,
  certifiedIns,
  identity,
  checkIdentitySection,
  vitaleIndex,
  insFromVitaleCard,
  insiConfig,
  runOnMount,
  checkOnMount,
  showLoading,
  dmpStatusCall,
  ins2Patient,
  insiOnly,
  subSection,
  vitaleCardStatus,
  tlsiConnectorSection,
  apiType,
  vitaleXml,
  insQualification,
  forceSynchronous,
}) => {
  const [isRunning, setIsRunning]           = React.useState(false);
  const [checkIsRunning, setCheckIsRunning] = React.useState(false);
  const [ins, setIns]                       = React.useState(certifiedIns);
  React.useEffect(() => {
    if ( // we already have an identity, so we check it
      (apiType === API_TYPES.REST || isReady(tlsiConnectorSection))
      && !checkIsRunning
      && runOnMount
      && checkOnMount
      && isReady(identity)
      && identity.i_insIdentityResult === 2
      && !hasError(checkIdentitySection)
      && !isLoading(checkIdentitySection)
      && !isLoading(identity)
      && insiConfig.active === true
    ) {
      setCheckIsRunning(true);
      dispatch(checkAndGetINSiIdentity({
        identity,
        subSection: subSection || certifiedIns,
      }));
    } else if ( // we didn't receive a certified ins, go get one
      (apiType === API_TYPES.REST || isReady(tlsiConnectorSection))
      && !isRunning
      && runOnMount
      && !certifiedIns
      && !isReady(identity)
      && !isLoading(identity)
      && !hasError(identity)
      && insiConfig.active === true
      // && (apiType !== API_TYPES.REST || (isReady(vitaleXml) && vitaleXml.xmlPatients !== undefined))
    ) {
      setIsRunning(true);
      dispatch(getInsFromVitaleCard({
        ins2Patient,
        insFromVitaleCard,
        vitaleIndex,
        dmpStatusCall,
        subSection,
        vitaleCardStatus,
        vitaleXml,
        forceSynchronous,
      }));
    }
  }, [
    isRunning,
    certifiedIns,
    vitaleIndex,
    isReady(identity),
    isLoading(identity),
    hasError(identity),
    dmpStatusCall,
    ins2Patient,
    subSection,
    runOnMount,
    checkOnMount,
    insiConfig.active,
    identity,
    apiType,
    vitaleXml,
  ]);
  
  React.useEffect(() => {
    if (isReady(identity)) {
      setIsRunning(false);
      
      if (identity.i_insIdentityResult === 2) {
        setIns(getQualifiedInsINSi(identity, vitaleCardStatus));
      } else {
        setIns(null);
      }
    } else {
      setIns(null);
    }
  }, [isReady(identity), vitaleCardStatus]);
  
  React.useEffect(() => {
    if (hasError(identity)) {
      setIsRunning(false);
    }
  }, [hasError(identity)]);
  
  if (
    insiConfig.active !== true
  ) {
    if (insiOnly) {
      
      return React.cloneElement(children, {
        certifiedIns: certifiedIns,
        vitaleIndex : vitaleIndex,
        nir         : insFromVitaleCard,
      });
    }
    
    return (
      <TD0IdentityProvider
        vitaleIndex={vitaleIndex}
        nir={insFromVitaleCard}
        certifiedIns={certifiedIns}
        runOnMount={runOnMount}
      >
        {children}
      </TD0IdentityProvider>
    );
  }
  
  return (
    <SectionStatusWrapper
      error={false}
      loading={showLoading && (isLoading(identity) || isLoading(checkIdentitySection))}
      loadingContent={<Loading centered={false} size="sm" message={null}/>}
      showChildrenOnError
    >
      {
        React.cloneElement(children, {
          certifiedIns           : ins || certifiedIns,
          certifiedIdentity      : identity.Identity || {},
          certifiedInsError      : hasError(identity) || identity.i_insIdentityResult !== 2,
          certifiedInsLoading    : isLoading(identity),
          certifiedInsReady      : isReady(identity) && identity.i_insIdentityResult === 2,
          vitaleIndex            : identity && identity.params ? identity.params.vitaleIndex : vitaleIndex,
          certifiedIdentityResult: identity,
          subSection             : subSection,
          insQualification,
        })
      }
    </SectionStatusWrapper>
  );
};

function mapStateToProps (state, props) {
  const {
          insFromVitaleCard, vitaleIndex, certifiedIns, subSection, originalInsType,
        }          = props;
  const {
          dmpconnect: {
            [apiSections.TLSI_CONNECTOR_SECTION]    : tlsiConnectorSection  = {},
            [apiSections.INS_FROM_VITALE_CARD]      : insiIdentitiesSection = {},
            [apiSections.INSI_CHECK_IDENTITY]       : {
              [subSection || certifiedIns]: checkIdentitySection = {},
            }                                                               = {},
            [apiSections.VITALE_DATA_SECTION]       : { i_cardStatus }      = {},
            [apiSections.VITALE_XML_CONTENT_SECTION]: vitaleXml,
          },
        }          = state;
  const insiConfig = getInsiConfig(state);
  
  let identity    = {};
  let indexVitale = vitaleIndex;
  let nir         = insFromVitaleCard;
  
  if (certifiedIns) {
    identity = getCertifiedIdentityFromIns(state, certifiedIns);
  } else if (subSection) {
    identity = insiIdentitiesSection[subSection] || {};
    
    if (!identity) {
      const cachedIdentity = getPatientInsiIdentityFromAccessibleDMPsCache(state, subSection);
      if (cachedIdentity) {
        identity = cachedIdentity;
      }
    }
    
    identity = { ...identity, Identity: fixQualifIdentityOid(identity.Identity, originalInsType) };
    if (identity.params) {
      const vitaleIndexParam = identity.params.vitaleIndex;
      indexVitale            = vitaleIndexParam >= 0 ? vitaleIndexParam : -1;
      nir                    = identity.params.insFromVitaleCard || '';
    }
  } else if (insFromVitaleCard && Number(vitaleIndex) >= 0) {
    identity = insiIdentitiesSection[`${insFromVitaleCard}_${vitaleIndex}`] || {};
    identity = { ...identity, Identity: fixQualifIdentityOid(identity, null, i_cardStatus) };
  }
  
  return {
    apiType          : getApiType(state),
    vitaleXml,
    tlsiConnectorSection,
    vitaleIndex      : indexVitale,
    insFromVitaleCard: nir,
    identity,
    insiConfig,
    vitaleCardStatus : i_cardStatus,
    checkIdentitySection,
    insQualification : getInsQualification(state, identity),
  };
}

INSiIdentityProvider.propTypes = {
  children            : PropTypes.node.isRequired,
  apiType             : PropTypes.string.isRequired,
  dispatch            : PropTypes.func.isRequired,
  certifiedIns        : PropTypes.string,
  tlsiConnectorSection: PropTypes.object,
  identity            : PropTypes.object,
  vitaleXml           : PropTypes.object,
  checkIdentitySection: PropTypes.object,
  vitaleIndex         : PropTypes.number,
  insFromVitaleCard   : PropTypes.string,
  insiConfig          : PropTypes.object.isRequired,
  runOnMount          : PropTypes.bool.isRequired,
  showLoading         : PropTypes.bool,
  dmpStatusCall       : PropTypes.bool,
  ins2Patient         : PropTypes.object,
  insiOnly            : PropTypes.bool,
  subSection          : PropTypes.string,
  vitaleCardStatus    : PropTypes.number,
  checkOnMount        : PropTypes.bool,
  showChildrenOnError : PropTypes.bool,
  originalInsType     : PropTypes.string,
  forceSynchronous: PropTypes.bool,
};

INSiIdentityProvider.defaultProps = {
  vitaleIndex         : -1,
  insFromVitaleCard   : null,
  certifiedIns        : null,
  tlsiConnectorSection: {},
  identity            : {},
  checkIdentitySection: {},
  vitaleXml           : {},
  showLoading         : false,
  dmpStatusCall       : true,
  ins2Patient         : undefined,
  insiOnly            : false,
  subSection          : null,
  vitaleCardStatus    : null,
  checkOnMount        : false,
  showChildrenOnError : true,
  originalInsType     : undefined,
  forceSynchronous: false,
};

const ConnectedINSiIdentity = CheckAccessRights(connect(mapStateToProps)(INSiIdentityProvider));

export default ConnectedINSiIdentity;
